import jwt from 'jwt-simple';
import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
const secret = process.env.REP_RESOURCES_SECRET;

const rucTDE = '1792073634001';
const toyotaMainAgency = '02';

const INITIAL_STATE = {
  'user': '',
  'userName': '',
  'userLastName': '',
  'photo': '',
  'roles': [],
  'token': '',
  'requestPartyToken': '',
  'grantedPermissions': false,
  'permissions': [],
  'currentLoginDate': '',
  'lastLoginDate': '',
  'loadingUserInfo': false,
  'dealerId': '',
  'dealerAgency': '',
  'isUserFromTDE': false,
  'userEmail': null,
};

const decodeRequestPartyToken = (requestPartyToken) => {
  const decoded = jwt.decode(requestPartyToken, secret, true, 'HS256');
  return decoded.authorization.permissions;
};

export const session = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.USER_LOGIN_SUCCESS]: (state, action) => ({
      ...state,
      'token': action.payload.token,
      'userLastName': action.payload.tokenParsed.family_name,
      'userName': action.payload.tokenParsed.given_name,
      'user': action.payload.tokenParsed.preferred_username,
      'roles': action.payload.tokenParsed.realm_access.roles,
      'currentLoginDate': action.payload.tokenParsed.auth_time,
    }),
    [ActionTypes.GET_USER_INFO_REQUEST]: (state, action) => ({
      ...state,
      'loadingUserInfo': true,
    }),
    [ActionTypes.GET_USER_INFO_SUCCESS]: (state, action) => {
      const dealerId = action.response.dealerId ? action.response.dealerId : rucTDE;
      const dealerAgency = action.response.dealerAgency ? action.response.dealerAgency : toyotaMainAgency;
      const userEmail = action.response.email ? action.response.email : null;
      return ({
        ...state,
        dealerId,
        dealerAgency,
        'photo': action.response.photo,
        'loadingUserInfo': false,
        'isUserFromTDE': dealerId === rucTDE,
        userEmail,
      });
    },
    [ActionTypes.GET_USER_INFO_FAILED]: (state, action) => ({
      ...state,
      'loadingUserInfo': false,
      'dealerId': '',
      'isUserFromTDE': false,
    }),
    [ActionTypes.USER_UPDATE_ACCESS_TOKEN]: (state, action) => ({
      ...state,
      'token': action.payload,
    }),
    [ActionTypes.REQUESTED_PARTY_TOKEN]: (state, action) => ({
      ...state,
      'requestPartyToken': action.response.rpt,
      'grantedPermissions': true,
      'permissions': decodeRequestPartyToken(action.response.rpt),
    }),
    [ActionTypes.REQUESTED_PARTY_TOKEN_FAILED]: (state, action) => ({
      ...state,
      'grantedPermissions': true,
    }),
    [ActionTypes.FETCHED_LAST_LOGIN]: (state, action) => ({
      ...state,
      'lastLoginDate': action.response.data.lastLoginDate,
    }),
  })(state, action);
};
